import { Metamodel } from '../base/model';
import { SqlServerLinkedService } from '../linkedservice/sql-server.linkedservice';
import { TabularTypeDataset } from './tabular-type.dataset';
import { IAttribute, IModel } from '../base/annotation';
import { ModelConstants } from '../model-constants';
import { format } from '../../shared/utils/string.util';
import { shellStringResources } from '../../Resources/ShellStringResources';

@Metamodel.model({
    name: ModelConstants.sqlServerDataset,
    display: [
        format(shellStringResources.ModelName_DatasetTemplate, shellStringResources.SqlServer_DisplayText),
        format(shellStringResources.ModelName_DatasetsTemplate, shellStringResources.SqlServer_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: SqlServerLinkedService.MODEL // Linked service redefined
        }
    }
})
export class SqlServerTableDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;

    public static DATABASE: IAttribute;
    @Metamodel.attribute({
        display: shellStringResources.Database,
        templatable: true,
        association: 'DATABASE'
    })
    public database?: string;

    public constructor(name?: string, description?: string) {
        super(name, description);
        this.isV2 = true;
    }
}
